import React from "react";
import { AlertTriangle } from "lucide-react";

export const SetupStateBadge = ({ testId, label = "MOCKED / SETUP REQUIRED" }) => (
  <span className="setup-badge" data-testid={testId}>
    <AlertTriangle size={13} aria-hidden="true" /> {label}
  </span>
);

export const ControlledErrorPanel = ({ title, message, onRetry, testId = "controlled-error-panel" }) => (
  <section className="ref-card settings-panel controlled-error-panel" data-testid={testId}>
    <SetupStateBadge testId={`${testId}-badge`} label="RECOVERY MODE" />
    <h1 data-testid={`${testId}-title`}>{title}</h1>
    <p data-testid={`${testId}-message`}>{message}</p>
    <button className="primary-button" onClick={onRetry} data-testid={`${testId}-retry-button`}>Reload APMS</button>
  </section>
);